import { render, staticRenderFns } from "./ServiceCards.vue?vue&type=template&id=6bec63c4&scoped=true&"
import script from "./ServiceCards.vue?vue&type=script&lang=js&"
export * from "./ServiceCards.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCards.vue?vue&type=style&index=0&id=6bec63c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec63c4",
  null
  
)

export default component.exports